import React, { Component } from 'react';
import RichTextEditor from 'react-rte';
import { EditorState } from 'draft-js';
import { translate as tl } from '../../../../utils/translation';

function withNewTabLinks(value) {
  const editorState = value.getEditorState();
  let contentState = editorState.getCurrentContent();
  const entityKeys = new Set();

  contentState.getBlockMap().forEach(block => {
    block.findEntityRanges(
      character => {
        const entityKey = character.getEntity();
        if (entityKey !== null) {
          entityKeys.add(entityKey);
        }
        return false;
      },
      () => {}
    );
  });

  entityKeys.forEach(entityKey => {
    const entity = contentState.getEntity(entityKey);
    if (entity.getType() !== 'LINK') {
      return;
    }

    const data = entity.getData();
    if (data.target === '_blank') {
      return;
    }

    contentState = contentState.mergeEntityData(entityKey, {
      target: '_blank'
    });
  });

  if (contentState === editorState.getCurrentContent()) {
    return value;
  }

  const nextEditorState = EditorState.acceptSelection(
    EditorState.push(editorState, contentState, 'apply-entity'),
    editorState.getSelection()
  );

  return value.setEditorState(nextEditorState);
}

export default class WYSIWYG extends Component {
  constructor(props) {
    super(props);
    // console.log(props.value);
    this.state = {
      value: RichTextEditor.createEmptyValue()
    };

    this.onChange = this.onChange.bind(this)
    this.setRoot = this.setRoot.bind(this)
    this.checkNewTabOption = this.checkNewTabOption.bind(this)
  }

  onChange(value) {
    value = withNewTabLinks(value);
    this.setState({ value });
    if (this.props.handleChange) {
      // Send the changes up to the parent component as an HTML string.
      this.props.handleChange(value.toString('html'));
      // console.log(value);
    }
  };

  componentDidMount() {
    if (window.MutationObserver && this.root) {
      this.observer = new window.MutationObserver(this.checkNewTabOption);
      this.observer.observe(this.root, { childList: true, subtree: true });
    }
  }

  componentWillUnmount() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value === undefined && this.props.value) {
      this.setState({
        value: RichTextEditor.createValueFromString(this.props.value, 'html')
      });
    }
  }

  setRoot(root) {
    this.root = root;
  }

  checkNewTabOption() {
    if (!this.root) {
      return;
    }

    Array.from(this.root.querySelectorAll('label')).forEach(label => {
      if (label.textContent.trim() !== 'Open link in new tab') {
        return;
      }

      const checkbox = label.querySelector('input[type="checkbox"]');
      if (checkbox && !checkbox.checked) {
        checkbox.click();
      }
    });
  }

  render() {
    const { headline, value } = this.props;

    if (value !== this.state.value) {
    }

    return (
      <div ref={this.setRoot}>
        <b>{tl(headline)}</b>
        <div className="form-group">
          <div className="input-group">
            <RichTextEditor
              value={this.state.value}
              onChange={this.onChange}
              className=""
            />
          </div>
        </div>
      </div>
    );
  }
}
